import { Pipe, PipeTransform } from '@angular/core'
import { BreakdownOriginType } from '@wm-front/shared/enums'

@Pipe({
  name: 'breakdownOriginType',
  standalone: true,
})
export class BreakdownOriginTypePipe implements PipeTransform {
  /** Transform breakdown origin type type into localised string
   * @param { BreakdownOriginType }
   * @returns { string }
   */
  public transform(value: BreakdownOriginType): string {
    switch (value?.trim()) {
      case BreakdownOriginType.DefectiveMaterial:
        return $localize`:Label | Value for the breakdown origin type defective material@@breakdownOriginTypeDefectiveMaterialLabel:Matériel défectueux`
      case BreakdownOriginType.Vandalism:
        return $localize`:Label | Value for the breakdown origin type vandalism@@breakdownOriginTypeVandalismLabel:Vandalisme`
      case BreakdownOriginType.Misuse:
        return $localize`:Label | Value for the breakdown origin type misuse@@breakdownOriginTypeMisuseLabel:Mauvaise utilisation`
      case BreakdownOriginType.External:
        return $localize`:Label | Value for the breakdown origin type external cause@@breakdownOriginTypeExternalCauseLabel:Cause externe`
      case BreakdownOriginType.WorksAtArrival:
        return $localize`:Label | Value for the breakdown origin type works at arrival@@breakdownOriginTypeWorksAtArrivalCauseLabel:Fausse alerte`
      case BreakdownOriginType.NoCause:
        return $localize`:Label | Value for the breakdown origin type no cause@@breakdownOriginTypeNoCauseLabel:NC`
      default:
        return $localize`:Label | Default value for the device component type@@breakdownOriginTypeOtherLabel:Autre`
    }
  }
}
